import styled from 'styled-components';

import breakpoints from '@/theme/constants/breakpoints';
import container from '@/theme/constants/container';
import typography from '@/theme/typography';
import {sizePx} from '@/theme/helpers/size';

export const StyledPageNotFound = styled.div`
  max-width: ${container.maxWidth};
  margin: ${sizePx(20)} auto;
  padding: 0 ${sizePx(8)};
  display: grid;

  @media only screen and ${breakpoints.device.m} {
    grid-template-columns: 1fr 1fr;
  }
`;

export const Styled404TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: ${sizePx(8)};

  & > h1 {
    ${typography.Section}
  }
  & > p {
    ${typography.Subtitle1}
  }
`;

export const Styled404ImageContainer = styled.div`
  display: flex;
  justify-content: center;

  & > img {
    max-width: 100%;
  }
`;
